export default "__VITE_ASSET__DEx0H_PH__"